import React, { FC, ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Eyebrow from "./Eyebrow";
import { tokens } from "../../styles/tokens";

export interface SectionProps {
  eyebrow?: string;
  title?: string;
  description?: ReactNode;
  /** Rendered on the title row, right-aligned — e.g. a "View all" link. */
  action?: ReactNode;
  children?: ReactNode;
  sx?: object;
}

/**
 * A page section with the site's container width and vertical rhythm.
 */
const Section: FC<SectionProps> = ({
  eyebrow,
  title,
  description,
  action,
  children,
  sx,
}) => (
  <Box
    component="section"
    sx={{
      width: `min(100%, ${tokens.space.containerMax}px)`,
      mx: "auto",
      px: { mobile: 2.5, tablet: 4, laptop: 5 },
      py: { mobile: 4, laptop: 6 },
      ...sx,
    }}
  >
    {(eyebrow || title || action) && (
      <Box
        sx={{
          display: "flex",
          alignItems: { mobile: "flex-start", tablet: "flex-end" },
          justifyContent: "space-between",
          flexDirection: { mobile: "column", tablet: "row" },
          gap: 2,
          mb: 3,
        }}
      >
        <Box>
          {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
          {title && <Typography variant="h2">{title}</Typography>}
          {description && (
            <Typography variant="body1" sx={{ mt: 1.5, maxWidth: 640 }}>
              {description}
            </Typography>
          )}
        </Box>
        {action}
      </Box>
    )}
    {children}
  </Box>
);

export default Section;
